import { IAppState } from '../../../../../AppModulesWrapper';
import { TOnCheckServiceChangeEventData } from '../../../../../AppModulesWrapper/services/appEvent/types';
import { selectIsAutoProlongChecked, selectIsInsufficientFunds } from '../../../../selectors/checkoutInfo';
import {
  selectIsSubagentMasterAccountMoneyLimitExceeded,
  selectRecommendedDepositAmount,
} from '../../../../selectors/balance';
import {
  selectActiveService,
  selectCheckoutDetails,
  selectIsUnavailableImportOfferPromotionForSelfMoneySource,
  selectPublicationTokens,
  selectServiceUnavailableReason,
} from '../../../../selectors/publishTerms';
import { selectPlacingMoneySource } from '../../../../reducers/v2/moneySources/selectors';
import { getPublishTerms } from '../../../../utils/getPublishTerms';
import { mapInternalServiceTypes } from '../../../../utils/publishTerms';
import { ICheckPublishTermSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';

export function prepareParams(state: IAppState): TOnCheckServiceChangeEventData {
  const isInsufficientFunds = selectIsInsufficientFunds(state);
  const shouldSwitchToSelf = selectIsSubagentMasterAccountMoneyLimitExceeded(state);
  const shouldSwitchToMaster = selectIsUnavailableImportOfferPromotionForSelfMoneySource(state);

  return {
    unavailableReason: selectServiceUnavailableReason(state),
    autoprolong: selectIsAutoProlongChecked(state),
    moneySource: selectPlacingMoneySource(state),
    terms: getPublishTerms(state),
    needToPay: Boolean(selectCheckoutDetails(state).length),
    recommendedDepositAmount: selectRecommendedDepositAmount(state),
    publicationTokens: selectPublicationTokens(state),
    promotionTerm: mapPromotionTerm(state) as ICheckPublishTermSchema,
    notEnoughMoney: shouldSwitchToSelf ? false : isInsufficientFunds,
    shouldSwitchToSelf,
    shouldSwitchToMaster,
  };
}

function mapPromotionTerm(state: IAppState) {
  const activeService = selectActiveService(state);

  if (!activeService) {
    return null;
  }

  return {
    type: activeService.tariffIdentificator.days > 1 ? 'periodical' : 'dailyTermless',
    days: activeService.tariffIdentificator.days,
    tariffIdentificator: activeService.tariffIdentificator,
    services: mapInternalServiceTypes(activeService.tariffIdentificator.serviceTypes),
    token: activeService.token,
  };
}
